<template>
  <div class="products-overview-categories">
    <ul class="products-overview-categories__list">
      <template v-for="(category, index) of categories">
        <ProductsOverviewCategoriesItem
          :key="`product-category- ${index}`"
          :category="category" />
      </template>
    </ul>
  </div>
</template>

<script>
  import ProductsOverviewCategoriesItem from './ProductsOverviewCategoriesItem';

  export default {
    name: `ProductsOverviewCategories`,
    components: { ProductsOverviewCategoriesItem },
    data() {
      return {

      };
    },
    props: {
      /**
       {
          count: number;
          isParentCategory: boolean;
          link: string;
          name: string;
        }[]
       */
      categories: {
        required: true,
        type: Array,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-variables';

  .products-overview-categories {
    background-color: @colorWhite;

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
    }
  }
</style>
